<script lang="ts" setup>
import {useAppStore} from "@/store";
import {storeToRefs} from "pinia";
import {onMounted} from "vue";

const appStore = useAppStore();
const {showTabBar, copyRightBottom, zIndex} = storeToRefs(appStore)

onMounted(() => {
  setTimeout(() => {
    appStore.setCopyRightBottom()
  }, 0)
})

</script>

<template>
  <div class="copy-right">大简易经，简单的易经</div>
</template>

<style scoped lang="less">
.copy-right {
  position: fixed;
  color: #9F9F9F;
  font-size: 14px;
  bottom: v-bind('copyRightBottom');
  text-align: center;
  z-index: v-bind('zIndex');
  width: 100%;
}

</style>
